import Slide0 from './components/Slide0.vue'
import Slide1 from './components/Slide1.vue'
import Slide2 from './components/Slide2.vue'
import Slide3 from './components/Slide3.vue'
import Slide4 from './components/Slide4.vue'
import Slide5 from './components/Slide5.vue'
import Slide6 from './components/Slide6.vue'
import Slide7 from './components/Slide7.vue'
import Slide8 from './components/Slide8.vue'
import Slide9 from './components/Slide9.vue'
import Slide10 from './components/Slide10.vue'
import Slide11 from './components/Slide11.vue'
import Slide12 from './components/Slide12.vue'
import Slide13 from './components/Slide13.vue'
import Slide14 from './components/Slide14.vue'
import Slide15 from './components/Slide15.vue'
import Slide16 from './components/Slide16.vue'
import Slide18 from './components/Slide18.vue'
import Slide19 from './components/Slide19.vue'
import Slide20 from './components/Slide20.vue'
import Slide21 from './components/Slide21.vue'
import Slide22parent from './components/Slide22parent.vue'
import Slide22 from './components/Slide22.vue'
import Slide23 from './components/Slide23.vue'
import Slide24 from './components/Slide24.vue'
import Slide25 from './components/Slide25.vue'
import Slide26 from './components/Slide26.vue'
import Slide27 from './components/Slide27.vue'
import Slide29 from './components/Slide29.vue'
import Slide30 from './components/Slide30.vue'
import Slide31 from './components/Slide31.vue'
import Slide32 from './components/Slide32.vue'
import Slide33 from './components/Slide33.vue'
import Slide35 from './components/Slide35.vue'
import Slide36 from './components/Slide36.vue'

import Timer from './components/Timer.vue'

export const routes= [
{   path: '/index.html',
    component: Slide0,
    alias: '/'
  },
  {
    path: '/',
    name: 'slide0',
    component: Slide0
  },
  {
    path: '/slide1/:lang',
    name: 'slide1',
    component: Slide1,
    props: true
  },
  {
    path: '/slide2/:lang',
    name: 'slide2',
    component: Slide2,
    props: true      
  },
  {
    path: '/slide3/:lang',
    name: 'slide3',
    component: Slide3,
    props: true      
  },
  {
    path: '/slide4/:lang',
    name: 'slide4',
    component: Slide4,
    props: true
  },
  {
    path: '/slide5/:lang',
    name: 'slide5',
    component: Slide5,
    props: true      
  },
  {
    path: '/slide6/:lang',
    name: 'slide6',
    component: Slide6,
    props: true      
  },
  {
    path: '/slide7/:lang',
    name: 'slide7',
    component: Slide7,
    props: true      
  },
  {
    path: '/slide8/:lang',
    name: 'slide8',
    component: Slide8,
    props: true      
  },
  {
    path: '/slide9',
    name: 'slide9',
    component: Slide9,
    children: [
      {
        path: 'slide10/:lang',
        name: 'slide10',
        component: Slide10,
        props: true      
      },
      {
        path: 'slide11/:lang',
        name: 'slide11',
        component: Slide11,
        props: true      
      },
      {
        path: 'slide12/:lang',
        name: 'slide12',
        component: Slide12,
        props: true      
      },
      {
        path: 'slide13/:lang',
        name: 'slide13',
        component: Slide13,
        props: true      
      },
      {
        path: 'slide14/:lang',
        name: 'slide14',
        component: Slide14,
        props: true      
      }      
    ]
  },   
  {
    path: '/slide15/:lang',
    name: 'slide15',
    component: Slide15,
    props: true      
  },
  {
    path: '/slide16/:lang',
    name: 'slide16',
    component: Slide16,
    props: true      
  },
  {
    path: '/slide18/:lang',
    name: 'slide18',
    component: Slide18,
    props: true      
  },
  {
    path: '/slide19/:lang',
    name: 'slide19',
    component: Slide19,
    props: true      
  },
  {
    path: '/slide20/:lang',
    name: 'slide20',
    component: Slide20,
    props: true      
  },
  {
    path: '/slide21/:lang',
    name: 'slide21',
    component: Slide21,
    props: true      
  },
  {
    path: '/slide22parent',
    name: 'slide22parent',
    component: Slide22parent,
    children: [
      {
        path: 'slide22/:lang',
        name: 'slide22',
        component: Slide22,
        props: true      
      }
    ]           
  },  
  {
    path: '/slide23/:lang',
    name: 'slide23',
    component: Slide23,
    props: true      
  },
  {
    path: '/slide24/:lang',
    name: 'slide24',
    component: Slide24,
    props: true      
  },
  {
    path: '/slide25/:lang',
    name: 'slide25',
    component: Slide25,
    props: true      
  },
  {
    path: '/slide26/:lang',
    name: 'slide26',
    component: Slide26,
    props: true      
  },
  {
    path: '/slide27/:lang',
    name: 'slide27',
    component: Slide27,
    props: true      
  },
  {
    path: '/slide29/:lang',
    name: 'slide29',
    component: Slide29,
    props: true      
  },
  {
    path: '/slide30/:lang',
    name: 'slide30',
    component: Slide30,
    props: true      
  },
  {
    path: '/slide31/:lang',
    name: 'slide31',
    component: Slide31,
    props: true      
  },
  {
    path: '/slide32/:lang',
    name: 'slide32',
    component: Slide32,
    props: true      
  },
  {
    path: '/slide33/:lang',
    name: 'slide33',
    component: Slide33,
    props: true      
  }, 
  {
    path: '/slide35/:lang',
    name: 'slide35',
    component: Slide35,
    props: true
  },
  {
    path: '/slide36/:lang',
    name: 'slide36',
    component: Slide36,
    props: true      
  },
  {
    path: '/Timer',
    name: 'Timer',
    component: Timer     
  }
];

